module.exports = __webpack_public_path__ + "static/img/banner.018ece7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/banner.png
// module id = LGSj
// module chunks = 0